"use client"

import { configStore } from '@/stores/config-store'
import React, {
    useMemo,
    useEffect,
    useContext,
    createContext,
} from 'react'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const ConfigContext = createContext(null)

export const ConfigProvider = ({ children }) => {
    const config = configStore((state) => state.config)
    const hasHydrated = configStore((state) => state.hasHydrated)

    const contextValue = useMemo(() => config ?? {}, [config])

    return (
        <ConfigContext.Provider value={(contextValue && typeof contextValue == "string") ? JSON.parse(contextValue) : contextValue}>
            {hasHydrated && (
                <MainComponent>
                    {children}
                </MainComponent>
            )}
        </ConfigContext.Provider>
    )
}

const MainComponent = ({ children }) => {
    const config = configStore((state) => state.config)
    const refreshConfigByApi = configStore((state) => state.refreshConfigByApi)

    const fetchConfig = async () => {
        await refreshConfigByApi()
    }

    useEffect(() => {
        // if (config === null) {
        fetchConfig()
        // }
    }, [config])

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {children}
        </LocalizationProvider>
    )
}

export const useConfig = () => useContext(ConfigContext)

export { ConfigContext }
